import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Tooltip,
  IconButton,
  TextField,
  Dialog,
  DialogContent,
  Autocomplete,
} from "@mui/material";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { DataGrid, faIR } from "@mui/x-data-grid";
import CustomPagination from "../../components/CustomPagination";
import "react-lazy-load-image-component/src/effects/blur.css";
import DeleteRow from "../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { UseArticles } from "./UseArticles";
import { useSnackbar } from "notistack";

export default function AuthorsGrid(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { DeleteArticleAssistant, AddArticleAssistant, GetAuthors } =
    UseArticles();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [openDialog, setOpenDialog] = useState(false);
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [searchSubGroup, setSearchSubGroup] = useState("");
  const [filt, setFilt] = useState([]);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  const [state, setState] = useState({
    id: 0,
    articleID: "",
    authorID: "",
  });
  const [authors, setAuthors] = useState();

  useEffect(() => {
    GetAuthors((authors) => {
      setAuthors(authors.authors);
    });
  }, []);

  useEffect(() => {
    setFilt([
      {
        columnField: "author",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const newFunc = () => {
    setOpenDialog(true);
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
    },
    {
      field: "author",
      width: 300,
      align: "center",
      headerName: "نام نویسنده",
      headerAlign: "center",
    },
    {
      field: "حذف",
      sortable: false,
      width: 100,
      headerAlign: "center",
      align: "center",
      headerName: "حذف",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="حذف">
            <IconButton
              onClick={() => {
                setDeleteState({
                  show: true,
                  name: cellValues.row.author,
                  id: cellValues.row.id,
                });
              }}
            >
              <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <TextField
            placeholder="جستجو"
            size="small"
            variant="outlined"
            value={searchSubGroup}
            inputProps={{ "aria-label": "search" }}
            onChange={(evt) => {
              setSearchSubGroup(evt.target.value);
            }}
          />
        );
      },
    },
  ];

  return (
    <Box sx={{ height: "30rem" }}>
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        open={openDialog}
        onClose={() => {
          setState({
            articleID: props.articleID,
            authorID: "",
          });
          setOpenDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Autocomplete
              size="small"
              value={state.authorID ? state.authorID : ""}
              onChange={(event, newValue) => {
                setState({ articleID: props.articleID, authorID: newValue });
              }}
              isOptionEqualToValue={(option, value) => {
                return value == "" || option === value;
              }}
              getOptionLabel={(option) => {
                if (option) {
                  return authors?.find((m) => m.id == option)?.author;
                }
                return "";
              }}
              sx={{ width: "70%", mb: 3 }}
              options={authors ? authors.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="نویسنده" />
              )}
            />
            <Box>
              <Button
                onClick={() => {
                  if (
                    state.authorID == "" ||
                    state.authorID == undefined ||
                    state.authorID == null
                  ) {
                    enqueueSnackbar("لطفا نویسنده را وارد کنید", {
                      variant: "error",
                      autoHideDuration: 2000,
                      preventDuplicate: true,
                    });
                    return;
                  } else {
                    setProgress(true);
                    AddArticleAssistant(state, () => {
                      setState({
                        articleID: props.articleID,
                        authorID: "",
                      });
                      props.callback();
                      setOpenDialog(false);
                    });
                  }
                }}
                color="secondary"
                variant="contained"
              >
                ثبت
              </Button>
              <Button
                sx={{ ml: 2 }}
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setState({
                    articleID: props.articleID,
                    authorID: "",
                  });
                  setOpenDialog(false);
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      <DataGrid
        className="ltr-grid"
        filterModel={{
          items: filt,
        }}
        localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
        columns={columns}
        rows={props.rows ? props.rows : []}
        page={pageState.page - 1}
        pageSize={20}
        Pagination
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...pageState, page: newPage + 1 }));
        }}
        rowCount={props.rows && props.rows.length ? props.rows.length : 1}
        disableColumnMenu
        hideFooterSelectedRowCount
        components={{
          Pagination: CustomPagination,
        }}
        componentsProps={{
          pagination: {
            newFunc: newFunc,
            isLtr: true,
            rowCount: props.rows && props.rows.length ? props.rows.length : "",
          },
        }}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "rowIndex",
                sort: "asc",
              },
            ],
          },
        }}
      />
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"نویسنده"}
        callback={() => {
          setProgress(true);
          DeleteArticleAssistant(deleteState.id, () => {
            props.callback();
          });
        }}
      ></DeleteRow>
    </Box>
  );
}
